import { Box, styled } from "@mui/material";

export const UserDirectoryContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 48px);
`;

export const UserDirectoryPanelBox = styled(Box)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 10px;
  padding-top: 1px;
`;

export const UserDirectoryPanel = styled(Box)`
  padding: 5px;
`;

export const UserDirectoryTabItemWrapper = styled(Box)`
  height: 100%;
`;

export const UserDirectorySearchWrapper = styled(Box)`
  padding: 10px 10px 0 10px;
`;
